import React, { useEffect, useState } from "react";
import Navbar from "./home_component/QuickAccess";
import Hero from "../pages/home_component/Hero";
import HowItWorks from "../pages/home_component/HowItWorks";
import WhyChooseUs from "../pages/home_component/WhyChooseUs";
import Programs from "../pages/home_component/Programs";
import SocialProof from "../pages/home_component/SocialProof";
import FinalCTA from "../pages/home_component/FinalCTA";


import FloatingWhatsapp from "../pages/home_component/FloatingWhatsapp";

const CONTACT_NUMBER = "+234 813 870 3959";

const Home = () => {
  const [showAssessment, setShowAssessment] = useState(false);

  // body scroll lock while modal open
  useEffect(() => {
    document.body.style.overflow = showAssessment ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [showAssessment]);

  const handleAssessmentSubmit = async (payload) => {
    // TODO: replace with your real API endpoint
    // await fetch("/api/assessments", { method: "POST", headers: {"Content-Type":"application/json"}, body: JSON.stringify(payload) });
    localStorage.setItem("ts_assessment_lead", JSON.stringify(payload));
    window.location.href = "/maths-assessment";
  };

  return (
    <>
      
      <Navbar onOpenAssessment={() => setShowAssessment(true)} />

      <main className="bg-white text-gray-900 font-sans">
        <Hero onOpenAssessment={() => setShowAssessment(true)} />

        {/* Section 2 – Free Assessment explainer lives inside HowItWorks */}
        <HowItWorks onOpenAssessment={() => setShowAssessment(true)} />

        <WhyChooseUs />
        <Programs onOpenAssessment={() => setShowAssessment(true)} />

        <SocialProof
          codingPageUrl="https://www.facebook.com/YOUR_CODING_ACADEMY_PAGE"
          invitePageUrl="https://www.facebook.com/YOUR_SMART_INVITE_PAGE"
        />

        <FinalCTA onOpenAssessment={() => setShowAssessment(true)} />
      </main>

      

      {/* Rectangular pop-up modal */}
      {/* <AssessmentModal
        open={showAssessment}
        onClose={() => setShowAssessment(false)}
        onSubmit={handleAssessmentSubmit}
      /> */}

      {/* Floating phone button with pop-up */}
       <FloatingWhatsapp />
    </>
  );
};

export default Home;
